import { useQuery } from 'react-query';
import api from 'src/services/api';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { ENVIRONMENT_NAME_QUERY_KEY } from 'src/constants/query';
import ApplicationsService from 'src/services/applications.service';

const ENVIRONMENT_STATUS_SETTINGS_QUERY_KEY = 'environmentStatusSettings';

const getStatusSettings = async ({ customerEnvId }) =>
  api.get(`/customerEnvironment/${customerEnvId}/statusSettings`);

export const useStatusSettings = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery(
    [ENVIRONMENT_STATUS_SETTINGS_QUERY_KEY, customerEnvId],
    () => getStatusSettings({ customerEnvId }),
    {
      enabled: !!customerEnvId,
      refetchOnWindowFocus: false,
    },
  );
};

export const useEnvironment = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const query = useQuery(
    [ENVIRONMENT_NAME_QUERY_KEY, customerEnvId],
    () => ApplicationsService.getEnvironment(customerEnvId),
    {
      enabled: !!customerEnvId,
      refetchOnWindowFocus: false,
    },
  );

  return { ...query, customerEnvId };
};
